import styled from 'styled-components';

import { size, rgba } from '../layout/helpers';
import { theme } from '../layout/theme';

export const List = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${rgba(theme.colors.bg.alt, 0.05)};
    height: ${size(0.25)};
    border-top: 1px solid transparent;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${rgba(theme.colors.bg.alt, 0.3)};
    height: ${size(0.25)};
    border-top: 1px solid transparent;
    background-clip: padding-box;
  }
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  white-space: nowrap;

  svg {
    margin: 2px ${size(1)} 0;
  }

  &:last-child {
    svg {
      display: none;
    }
  }

  ${theme.screens.LtMd} {
    font-size: 13px;
  }
`;
